/* 🤖 this file was generated by svg-to-ts */
export const matIconFilterCenterFocus: {
  name: 'filter-center-focus';
  data: string;
} = {
  name: 'filter-center-focus',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>`
};
